import { Injectable, EventEmitter } from '@angular/core';
import { Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class CityInputValidationService {

  inputs = {};
  validityChanged: EventEmitter<{inputID:string, isValid:boolean, description: string}> ;
  
  
  constructor() { 
    this.validityChanged = new EventEmitter<{inputID:string, isValid:boolean, description: string}>();

  }

  public setInvalid(inputID:string, validatorDescript: string){
    this.inputs[inputID] = false ;
    this.validityChanged.emit( {inputID: inputID, isValid: false, description: validatorDescript })

  }
  
  public setValid(inputID:string, validatorDescript: string){
    this.inputs[inputID] = true ;
    this.validityChanged.emit( {inputID: inputID , isValid: true, description: validatorDescript })

  }
    
  public isValid( inputID: string ){
    if( this.inputs[inputID] ){
      return this.inputs[inputID];
    }else{
      return undefined;
    }
  }

  public addInput( inputID: string){
    if( ! this.inputs[inputID] ){
      this.inputs[inputID] = new BehaviorSubject<boolean>(false);
    }

  }

  public getInput( inputID: string ){
    if( this.inputs[inputID] ) return this.inputs[inputID].asObservable();
    else return undefined;
  }
  
    

}